module.exports = __webpack_public_path__ + "static/media/Bitmap Copy@2x.6182942f.png";